import { useState, useRef, useEffect } from 'react'
import {Formik, Field, Form} from 'formik'

import Modal from 'react-bootstrap/Modal'
import {JSONFetcher, FormGroup, Button, FormTextArea, DISHtml} from 'shared'

export const ThankYouMessageButton = (props) => {
  const [showModal, setShowModal] = useState(false)
  const [data, setData] = useState(props)

  const closeModal = () => setShowModal(false)
  const openModal = (event) => {
    if (event) event.preventDefault()
    setShowModal(true)
  }

  return <div>
    <TYButton {...data} onClick={openModal} />

    <Modal className='generic-modal-window' size='lg' show={showModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <h1>{I18n.t('modules.thank_you_message.box_headline', { name: data.to })}</h1>
      </Modal.Header>
      <Modal.Body>
        {!data.sentAt && <p>
          <DISHtml value={I18n.t('modules.thank_you_message.introduction_html', { expires_at: data.expiresAt })} />
        </p>}
        {data.sentAt && <p>
          {I18n.t('modules.thank_you_message.sent_at_notice', { sent_at: data.sentAt })}
        </p>}
        <FormContent {...data} setData={setData} closeModal={closeModal} />
      </Modal.Body>
    </Modal>
  </div>
}

const TYButton = (props) => {

  if (props.state === 'sent') return <>
    <i className='fa fa-check text-green-medium mr-1' />
    {I18n.t('modules.thank_you_message.sent_label')}
    <button className='simulated-link d-block' onClick={props.onClick}>
      {I18n.t('modules.thank_you_message.view_label')}
    </button>
  </>
  if (props.state === 'expired') return I18n.t('modules.thank_you_message.expired_label')
  if (props.state === 'not_available') return I18n.t('modules.thank_you_message.not_available_label')

  return <button className='btn btn-primary' onClick={props.onClick}>
    {I18n.t('modules.thank_you_message.write_label')}
  </button>
}

const FormContent = (props) => {
  const initialValues = {
    from:      props.from,
    reply_to:  props.replyTo,
    to:        props.to,
    subject:   props.subject,
    body:      props.body,
  }
  const formRef = useRef()

  const submitHandler = (values, formikBag) => {
    JSONFetcher.post({
      url: props.submitUrl,
      jsonObject: {body: values.body},
      success: (response) => {
        formikBag.setSubmitting(false)
        props.setData(response)
        props.closeModal()
      }
    })
  }

  useEffect(() => {
    if (formRef.current) formRef.current.querySelector('textarea').focus()
  }, [formRef])

  // keep in sync with models/donation/thank_you_message.rb
  const validate = (values) => {
    const errors = {}
    if (!values.body) errors.body = I18n.t('misc.required_field')
    else if (values.body.length < 5) errors.body = I18n.t('errors.messages.too_short', { count: 5 })
    else if (values.body.length > 2048) errors.body = I18n.t('errors.messages.too_long', { count: 2048 })
    return errors
  }

  return <Formik
    initialValues={initialValues} onSubmit={submitHandler} validate={validate}>
    {formikProps => <Form ref={formRef}>
      <div className='d-flex'>
        <div className='flex-1'>
          <Field name='from' label={I18n.t('modules.thank_you_message.from_label')} readOnly={true} disabled={true} component={FormGroup} />
          <Field name='reply_to' label={I18n.t('modules.thank_you_message.reply_to_label')} readOnly={true} disabled={true} component={FormGroup} />
          <Field name='to' label={I18n.t('modules.thank_you_message.to_label')} readOnly={true} disabled={true} component={FormGroup} />
        </div>
        <div className='mx-3 desktop-only' style={{border: '1px solid #E9ECEE'}}></div>
        <div className='flex-1'>
          <DonorDetails {...props} />
        </div>
      </div>
      <Field name='subject' label={I18n.t('modules.thank_you_message.subject_label')} readOnly={true} disabled={true} component={FormGroup} />
      <Field name='body' label={I18n.t('modules.thank_you_message.body_label')} readOnly={props.sentAt} disabled={props.sentAt} component={FormTextArea} maxLength={2048} rows={3} />
      <p>
       <DISHtml value={props.greetings} />
      </p>
      {props.state === 'new' && <Button type='submit' loading={formikProps.isSubmitting} className='btn-large btn-primary'>
        {I18n.t('modules.thank_you_message.submit_button')}
      </Button>}
    </Form>}
  </Formik>
}

const DonorDetails = (props) => {
  const [data, setData] = useState()

  useEffect(() => {
    JSONFetcher.load({url: props.donorDetailsUrl, success: setData})
  }, [])

  if (!data) return null

  return <>
    <div>
      <strong>{I18n.t('modules.thank_you_message.donor_details_label')}</strong>
    </div>
    {data.summary}

    {data.comment && <div className='mt-2'>
      <strong>{I18n.t('modules.thank_you_message.donor_details_message')}</strong>
    </div>}
    {data.comment}

    <div className='mt-2'>
      <strong>{I18n.t('modules.thank_you_message.donor_details_headline', {name: props.to})}</strong>
    </div>
    <ul className='ml-0 font-size-14'>
      {data.additional.map((a, i) => <li key={i}>{a}</li>)}
    </ul>
  </>
}
